// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
}

.modal-main {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 33vw;
  min-width: 400px;
  max-width: 800px;
  max-height: 90vh;
  padding: 16px;
  padding-top: 24px;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  z-index: 5;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal.display-block {
  display: flex;
}

.display-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/SystemControlPage/Modals/addPersonModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAGE;EACE,aAAA;AAAJ;;AAGE;EACE,aAAA;AAAJ","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 4;\n}\n\n.modal-main {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 33vw;\n  min-width: 400px;\n  max-width: 800px;\n  max-height: 90vh;\n  padding: 16px;\n  padding-top: 24px;\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n  z-index: 5;\n  overflow-y: auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n  \n  .modal.display-block {\n    display: flex;\n  }\n\n  .display-none {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal`,
	"modal-main": `modal-main`,
	"display-block": `display-block`,
	"display-none": `display-none`
};
export default ___CSS_LOADER_EXPORT___;
